<template>
  <div id="contents">
    <div id="exCancle" class="container">
      <h3 class="stitle mb50">{{ reserveTitle }}</h3>
      <dl class="complet_box mb50">
        <dt>예약이 성공적으로 완료되었습니다.</dt>
        <dd v-if="isPledge">확약서 작성후 제출해주세요.</dd>
      </dl>
      <h4 class="stitle2 mb10 tleft">상품예약 및 결제내역</h4>
      <div class="tb_wrap">
        <table class="tb_basic">
          <caption>상품예약 및 결제내역</caption>
          <colgroup>
            <col />
            <col />
            <col />
            <col />
            <col />
          </colgroup>
          <thead>
            <tr class="tbg">
              <th scope="col">체험일</th>
              <th scope="col">상품</th>
              <th scope="col">회차</th>
              <th scope="col">인원</th>
              <th scope="col">금액</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(rv, i) in detailList" :key="rv.pdRvNo">
              <td v-if="i === 0" :rowspan="detailList.length">
                {{ rv.expVisitRvdtF }}
              </td>
              <td>
                {{ rv.pdNm }}
                <br />
                <a class="btn_print" @click="() => openConfirmCard(rv.pdRvNo)">확인증</a>
              </td>
              <td>{{ rv.scheSeqNm }}({{ rv.scheTm }})</td>
              <td class="tleft">
                <ul class="tlist1">
                  <li>
                    <strong>체험자</strong>
                    <span>{{ rv.experPcnt }}인</span>
                  </li>
                  <li v-if="rv.leaderPcnt > 0">
                    <strong>보호자</strong>
                    <span>{{ rv.leaderPcnt }}인</span>
                  </li>
                </ul>
              </td>
              <td class="tright">{{ _wonFormat(rv.rvAmt) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="totalPriceBox mb50">
        <ul class="div3">
          <li>
            <strong>체험금액</strong>
            <span>
              <i class="fs_big tcolor1">{{ _priceFormat(totOriginPrice) }}</i>
              원
            </span>
          </li>
          <li class="price_icon1">
            <strong>할인금액</strong>
            <span>
              <i class="fs_big">{{ _priceFormat(totDcPrice) }}</i>
              원
            </span>
          </li>
          <li class="price_icon3">
            <strong>총결제금액</strong>
            <span>
              <i class="fs_big">{{ _priceFormat(totSalePrice) }}</i>
              원
            </span>
          </li>
        </ul>
      </div>
      <div v-if="payInfo.payMethod === '04'" class="colorBox bankbook mb50">
        <dl>
          <dt class="stitle2 mb10">무통장입금(가상계좌)</dt>
          <dd>
            <ul>
              <li>
                <strong>{{ payInfo.nobankDpsBankNm }}은행</strong>
                <span>{{ payInfo.nobankAccNo }}</span>
              </li>
              <li>
                <strong>입금자명</strong>
                <span>{{ payInfo.nobankDpser }}</span>
              </li>
              <li>
                <strong>입금마감일</strong>
                <span>{{ payInfo.nobankDpsBdtDtF }}</span>
              </li>
            </ul>
            <span class="tcolor2">* 기간내 미입금시 주문이 자동으로 취소됩니다.</span>
          </dd>
        </dl>
      </div>
      <template v-if="isYouthOrSkill">
        <div v-if="!isGrpOrder" class="colorBox tcolor1 mb50">
          <span>- 청소년체험관은 원활한 체험을 위해 체험 시작 20분 경과 후 입장하실 경우 참관으로 진행되며, 30분 경과 시 입장이 제한됩니다.</span>
        </div>
        <div v-if="isPledge" class="colorBox mb50">
          <strong class="tcolor1">
            확약서 승인 후 체험실 선택이 가능합니다.
            <br />
            승인되면 문자를 전송해 드립니다.
          </strong>
          <br />
          &quot;예약/확인 &gt; 체험실선택&quot;에서 예약상품을 클릭하여 체험실을 선택하세요.
          <br />
          <span class="tcolor3">
            원활한 체험을 위해 체험실 좌석을 미리 신청하세요!
            <br />
            단 이용 당일 운영상황에 따라 일부 체험실이 미운영될 수 있습니다.
          </span>
        </div>
        <ul v-if="isGrpOrder && !isPledge" class="applybox mb10">
          <li>
            <dl>
              <dt class="stitle2 mb10">체험자 개별 신청</dt>
              <dd>
                체험자가 회원가입 후 로그인하여
                <br />
                원하는 체험실을 신청
              </dd>
            </dl>
          </li>
          <li>
            <dl>
              <dt class="stitle2 mb10">예약자 일괄 신청</dt>
              <dd>예약자가 체험실을 일괄 신청</dd>
              <dd class="ticket_btnbox"><a @click="goDetail" class="btn_write">신청하러 가기</a></dd>
            </dl>
          </li>
          <li>
            <dl>
              <dt class="stitle2 mb10">진로설계관 무료 프로그램 안내</dt>
              <dd class="ticket_btnbox"><a href="/reserve/grp/course/1129" target="_blank" class="btn_write">신청하러 가기</a></dd>
            </dl>
          </li>
        </ul>
        <p v-if="isGrpOrder && !isPledge" class="colorBox mb50">
          <span class="tcolor1">- 청소년체험관은 원활한 체험을 위해 체험 시작 20분 경과 후 입장하실 경우 참관으로 진행되며, 30분 경과 시 입장이 제한됩니다.</span><br/>
          <span class="tcolor2">※청소년 체험관/숙련기술 체험관은 체험일 하루 전 자정까지 체험실 선택을 반드시 하셔야 합니다.</span>
        </p>
      </template>
      <div class="btn_area">
        <a v-if="isGrpOrder && isPledge" class="btn btn_bg gray" @click="goDetail">확약서 작성</a>
        <a class="btn btn_bg gray" @click="goDetail">예약확인</a>
      </div>
    </div>
    <!--// .container-->
  </div>
</template>

<script>
import { getOrderSheet } from '@/api/api_reserve';
import { openConfirmCardPopup } from '@/utils/reserve';
import { toJspPage } from '@/utils/reserve';
import moment from 'moment';

export default {
  data() {
    return {
      bundleRvNo: '',
      isGrpOrder: false,
      isPledge: false,
      reserveTitle: '',
      reserveInfo: {},
      detailList: [],
      payInfo: {},
      isYouthOrSkill: false,
    };
  },
  computed: {
    totOriginPrice() {
      return this.detailList.reduce((a, e) => a + e.rvAmt + e.dcAmt, 0);
    },
    totDcPrice() {
      return this.detailList.reduce((a, e) => a + e.dcAmt, 0);
    },
    totSalePrice() {
      return this.detailList.reduce((a, e) => a + e.rvAmt, 0);
    },
  },
  methods: {
    async loadOrderSheet(bundleRvNo) {
      const res = await getOrderSheet(bundleRvNo);
      const data = res.data;
      if (data?.success) {
        const response = data.response;
        this.isGrpOrder = response.isGrpOrder;
        this.reserveTitle = response.isGrpOrder ? '단체예약' : '개인예약'; //처음 표시하지 않기위해서 computed 미사용
        this.isPledge = response.isPledge;
        this.detailList = response.detailList;
        this.isYouthOrSkill = response.isYouthOrSkill;

        if (response.payInfo) {
          const nobankDpsBdtDtF = moment(response.payInfo.nobankDpsBdtDt, 'YYYYMMDD').format('YYYY년MM월DD일');
          this.payInfo = { ...response.payInfo, nobankDpsBdtDtF };
        }
      }
    },
    openConfirmCard(pdRvNo) {
      openConfirmCardPopup(pdRvNo);
    },
    goDetail() {
      this.$router.push(`/${this.currentRouteType}/reservations/${this.bundleRvNo}`);
      //toJspPage('/resvr/reserveDetail.do', { bundleRvNo: this.bundleRvNo });
    },
  },
  created() {
    this.bundleRvNo = this.$route.params.bundleRvNo;
    this.loadOrderSheet(this.bundleRvNo);
    //20230118 카카오픽셀 태그 삽입 paymentvuecomplete
    kakaoPixel('203973471995934705').pageView();
    kakaoPixel('203973471995934705').signUp('SignUp');
    //20230130 네이버 태그 삽입vue
    var _nasa = {};
    if (window.wcs) _nasa['cnv'] = wcs.cnv('4', '10'); // 전환유형, 전환가치 설정해야함. 설치매뉴얼 참고
  },
};
</script>

<style>
.ticket_btnbox a {
  cursor: pointer;
}
</style>
